module.exports = __webpack_public_path__ + "img/loadingpic2.b168cc5f.gif";